import { Box, Flex, Skeleton } from '@skin-seoul/design-system';

export const LoyaltyPointsBannerSkeleton = () => {
  return (
    <Box
      position="relative"
      width="100%"
      borderRadius="8px"
      bg="neutral.100"
      overflow="hidden"
      px={4}
      py={{ base: 6, tablet: 4 }}
    >
      <Flex position="relative" zIndex={1} alignItems="center" justifyContent="space-between" height="100%">
        {/* Title Skeleton */}
        <Flex direction="column" gap={1}>
          <Skeleton height="20px" width="80px" />
          <Skeleton height="20px" width="100px" />
        </Flex>

        {/* Points Skeleton */}
        <Flex direction="column" gap={1} alignItems="flex-end">
          <Skeleton height="14px" width="70px" />
          <Skeleton height="24px" width="80px" />
        </Flex>
      </Flex>
    </Box>
  );
};


